import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAllRestrictionRuleSlice = createApi(`GetAllRestrictionRuleSlice`,"GET");

const GetAllRestrictionRuleSlice = createSlice({
  name: 'GetAllRestrictionRuleSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllRestrictionRuleSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllRestrictionRuleSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllRestrictionRuleSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllRestrictionRuleSlice.reducer;